import { Experience } from '../types';

export const experience: Experience[] = [
  {
    id: "1",
    company: "Applied Research Labs - Space and Geophysics Lab, University of Texas – Austin",
    position: "Senior Software Engineering Manager",
    startDate: "2021-07",
    endDate: "",
    location: "Austin, TX",
    description: "Direct lab-wide software engineering strategy, execution, and governance across $30M in active contracts while serving as product owner, technical lead, and individual contributor.",
    achievements: [
      "Provide strategic leadership to diverse technical team by driving 40% workforce growth, process consistency, and delivery performance while administering additional training.",
      "Recovered mission-critical system on time and under budget by re-baselining scope, staffing, and architecture for hardware and software program previously over one year delayed.",
      "Eliminate operational silos by creating SOPs and engineering processes, operating models, and best practices following organizational realignment, improving cross-team coordination.",
      "Institutionalize consistent performance feedback across company by designing structured review and coaching framework later adopted lab-wide, improving feedback quality.",
      "Build robust workforce infrastructure supporting rapid staff expansion by standardizing onboarding, training, and transition frameworks, maximizing production and engagement.",
      "Demonstrated excellent problem-solving skills by leading and resolving sensitive workforce decisions including targeted reductions and extended performance remediation.",
      "Architect scalable processing pipelines across deployed and cloud platforms while guiding all aspects of system design, throughput optimization, and on-premise to AWS transition.",
      "Own shared software platform supporting multiple teams and products while serving as subject matter expert, writing majority of codebase while leading design reviews."
    ],
    technologies: ["C++", "Python", "Cloud Infrastructure", "Software-Defined Radio", "High-Rate Data Processing", "DoD Systems"]
  },
  {
    id: "2",
    company: "Composites for Infrastructure",
    position: "Senior Software Engineer",
    startDate: "2017-01",
    endDate: "2020-12",
    location: "California and Texas",
    description: "Modernized manufacturing workflows through custom automation solutions by validating software-driven controls for factory operations, reducing manual intervention.",
    achievements: [
      "Exemplified exceptional critical thinking by implementing productivity metrics and reporting logic to measure processing capacity, utilization, and operational performance.",
      "Created C# applications interfacing with programmable logic controllers to synchronize hardware behavior and ensure consistent execution while determining optimal solutions.",
      "Expanded duties beyond core role within early-stage startup, assuming cross-functional ownership across technical and operational functions to support evolving business priorities"
    ],
    technologies: ["C#", "Python", "PLC Programming", "Automation Software", "Hardware Controls",  "Productivity Metrics"]
  },
  {
    id: "3",
    company: "GT Nexus",
    position: "Full Stack Software Engineer",
    startDate: "2013-06",
    endDate: "2016-09",
    location: "California",
    description: "Expanded enterprise platform adoption by building core functionality for multitenant supplychain product supporting global shipping workflows used by 94,000+ organizations.",
    achievements: [
      "Optimized queries, indexing, and database interactions across large Microsoft SQL Server instances to improve responsiveness while maintaining high-quality control standards.",
      "Developed server-side components supporting complex business logic, building Java J2EE and Spring Boot services managing multi-tenant data isolation and operations.",
      "Accelerated deployment cycles by partnering with interdisciplinary teams and offshore QAto validate functionality and reduce post-deployment issues through coordinated testing."
    ],
    technologies: ["Java", "J2EE", "SQL", "Full Stack Development", "Enterprise Software", "Multitenant Architecture", "Performance Tuning", "QA Coordination"]
  }
]; 